/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Onboarding} from '@gatewee/types/onboarding';
import {Recipient} from '@gatewee/types/recipient';

@Injectable({
  providedIn: 'root',
})
export class PublicService {
  constructor(private http: HttpClient) {}

  findOfficialData(document: string): Observable<Partial<Recipient>> {
    return this.http.get<Partial<Recipient>>('/recipients/public/' + document);
  }

  joinUs(recipient: Recipient): Observable<Recipient> {
    return this.http.post<Recipient>('/recipients/public/', recipient);
  }

  createOnboarding(onboarding: Partial<Onboarding>): Observable<Onboarding> {
    return this.http.post<Onboarding>('/onboardings/public', onboarding);
  }

  updateOnboarding(
    identifier: string,
    onboarding: Partial<Onboarding>,
  ): Observable<Onboarding> {
    return this.http.patch<Onboarding>(
      '/onboardings/public/' + identifier,
      onboarding,
    );
  }

  findOnboarding(identifier: string): Observable<Onboarding> {
    return this.http.get<Onboarding>('/onboardings/public/' + identifier);
  }

  findOnboardingKyc(identifier: string): Observable<Onboarding> {
    return this.http.get<Onboarding>('/onboardings/public/kyc/' + identifier);
  }
}
